const normalizeEnvironmentName = (value) =>
  String(value || "")
    .trim()
    .replace(/^["']|["']$/g, "")
    .toLowerCase();

export const getAssistantEnvironment = () =>
  normalizeEnvironmentName(import.meta.env.VITE_ENV || import.meta.env.MODE);

export const isAssistantStageEnvironment = () => {
  const environment = getAssistantEnvironment();
  return environment === "stage" || environment === "staging";
};

export const isAssistantMultilingualEnabled = isAssistantStageEnvironment;
